import { useContext } from "react";
import { PrescribeContext } from "./PrescribeProvider";

export const usePrescribe = () => useContext(PrescribeContext);
